import { render, staticRenderFns } from "./BoardAA.vue?vue&type=template&id=67b1850c&"
import script from "./BoardAA.vue?vue&type=script&lang=js&"
export * from "./BoardAA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports